import { createContext as t } from "react";
const o = t({
  name: "",
  value: ""
}), { Consumer: n } = o, { Provider: r } = o;
export {
  n as Consumer,
  o as Context,
  r as Provider
};
//# sourceMappingURL=context.js.map
